import { ListBoxChangeEvent } from "primereact/listbox";
import { useState } from "react";
import SubCategoryAPIDataSourceImpl from "../../Data/DataSource/API/SubCategoryAPIDataSource";
import { SubCategoryRepositoryImpl } from "../../Data/Repository/SubCategoryRepositoryImpl";
import { SubCategory } from "../../Domain/Model/SubCategory";
import { CreateSubCategory } from "../../Domain/UseCase/CreateSubCategory";
import { GetSubCategories } from "../../Domain/UseCase/GetSubCategories";
import { RemoveSubCategory } from "../../Domain/UseCase/RemoveSubCategory";
import { UpdateSubCategory } from "../../Domain/UseCase/UpdateSubCategory";

export default function LoginViewModel() {

    const [subCategories, setSubCategories] = useState<SubCategory[]>([]);
    const [viewSubCategory, setViewSubCategory] = useState<SubCategory[]>([]);

    const subCategoryDataSourceImpl = new SubCategoryAPIDataSourceImpl();
    const subCategoryRepositoryImpl = new SubCategoryRepositoryImpl(subCategoryDataSourceImpl);

    const getSubCategoriesUseCase = new GetSubCategories(subCategoryRepositoryImpl);
    const createSubCategoryUseCase = new CreateSubCategory(subCategoryRepositoryImpl);
    const removeSubCategoryUseCase = new RemoveSubCategory(subCategoryRepositoryImpl);
    const updateSubCategoryUseCase = new UpdateSubCategory(subCategoryRepositoryImpl);


    async function getSubCategories() {
        setSubCategories(await getSubCategoriesUseCase.invoke());
      }

      // function _resetValue() {
      //   setValue("");
      // }

      async function createSubCategory(data: any) {

        console.error("createSubCategory data:", data);
        
        try {
          const createdSubCategory = await createSubCategoryUseCase.invoke(data);
          if(createdSubCategory){
            //console.log("enviado");
            return true;
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            //console.log(e.message);
          }
        }
      }

      async function removeSubCategory(id: string) {
        try {
          let removedSubCategory = await removeSubCategoryUseCase.invoke(id);
          if(removedSubCategory){
            //console.log("eliminado");
           return removedSubCategory;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            //console.log(e.message);
          }
          return Error;
        }
      }

      async function updateSubCategory(data: SubCategory) {
        try {
          let updatedSubCategory = await updateSubCategoryUseCase.invoke(data);
          if(updatedSubCategory){
            //console.log("Actualizado");
           return updatedSubCategory;
          
          }
          //_resetValue();
        } catch (e) {
          //_resetValue();
          if (e instanceof Error) {
            //console.log(e.message);
          }
          return Error;
        }
      }

      

      function onChangeSubCategory(e: ListBoxChangeEvent) {
        e.preventDefault();
        setSubCategories(e.target.value);
      }
      const [disabledSelect, setDisabledSelect] = useState<boolean>(true);
      async function viewSubCategoryList(value: number): Promise<SubCategory[]> {
        const subcatAll = await getSubCategoriesUseCase.invoke();
        const list = subcatAll.filter((x)=> x.categoryId.toString() === value.toString());
   
        
        setDisabledSelect(false);
        // setIsSubCategoryReady(hasSubCategories);
        setViewSubCategory(list);

        console.log(list);
        return list;
    }
  //   const viewSubCategoryList = async (value: number) => {
  //     const list = subCategories.filter((x) => x.categoryId === value.toString());
  //     setDisabledSelect(false);
  //     setViewSubCategory(list);
      
  //     // Espera al siguiente ciclo de render para asegurar que el estado se haya actualizado
  //     await new Promise((resolve) => setTimeout(resolve, 0));
  
  //     console.log("Subcategorías actualizadas:", list);
  // };

      
      return {
        getSubCategories,
        createSubCategory,
        removeSubCategory,
        updateSubCategory,
        onChangeSubCategory,
        subCategories,
        viewSubCategory,
        viewSubCategoryList,
        disabledSelect,
      };
}

